// extracted by css-extract-rspack-plugin
export default {"root":"root-G8jXsO","group":"group-OFxJns","separator":"separator-JR_mwY","link":"link-_fOORN","userName":"userName-czBwjQ"};